import { render, staticRenderFns } from "./QRCodeRoomService.vue?vue&type=template&id=442e7826&scoped=true&"
import script from "./QRCodeRoomService.vue?vue&type=script&lang=js&"
export * from "./QRCodeRoomService.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeRoomService.vue?vue&type=style&index=0&id=442e7826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e7826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
